import React, { useState } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import GridContainer from '../../../../../../components/Grid/GridContainer';
import GridItem from '../../../../../../components/Grid/GridItem';
import enhancer from './enhancer';
import DateSelector from './DateSelector';
import TimeSelector from './TimeSelector';
import DependantDateSelector from './DependantDateSelector';
import { Toggler } from './style';
import { datesObjType, requestParamsType } from './types';

export const PickupDeliverySelectorComponent = ({
  needsPickup,
  needsDelivery,
  dependsOnPickup,
  pickupDates,
  deliveryDates,
  requestParams,
}) => {
  const [syncDeliveryDates, setSyncDeliveryDates] = useState(deliveryDates);
  return (
    <>
      <Toggler hidden={!needsPickup}>
        <GridContainer spacing={4}>
          <GridItem xs={6} lg={3}>
            <Field
              name="service.pickup.date"
              dates={pickupDates}
              component={DateSelector}
              label="Pickup Date"
            />
          </GridItem>
          <GridItem xs={6} lg={3}>
            <Field
              name="service.pickup.time"
              dates={pickupDates}
              component={TimeSelector}
              label="Pickup Time"
            />
          </GridItem>
        </GridContainer>
      </Toggler>
      <Toggler hidden={!needsDelivery}>
        <GridContainer spacing={4}>
          <GridItem xs={6} lg={3}>
            <Field
              name="service.delivery.date"
              dates={syncDeliveryDates}
              setDates={setSyncDeliveryDates}
              component={dependsOnPickup ? DependantDateSelector : DateSelector}
              label="Delivery Date"
              requestParams={requestParams}
            />
          </GridItem>
          <GridItem xs={6} lg={3}>
            <Field
              name="service.delivery.time"
              dates={syncDeliveryDates}
              component={TimeSelector}
              label="Delivery Time"
            />
          </GridItem>
        </GridContainer>
      </Toggler>
    </>
  );
};

PickupDeliverySelectorComponent.propTypes = {
  needsPickup    : PropTypes.bool.isRequired,
  needsDelivery  : PropTypes.bool.isRequired,
  dependsOnPickup: PropTypes.bool.isRequired,
  pickupDates    : datesObjType.isRequired,
  deliveryDates  : datesObjType.isRequired,
  requestParams  : requestParamsType.isRequired,
};

export default enhancer(PickupDeliverySelectorComponent);
